import { CancellationTokenSource } from "../shared/async/CancellationTokenSource";
import { PromiseCompletionSource } from "../shared/async/PromiseCompletionSource";
import { TickerDelay } from "./TickerDelay";

type CancellableOperation<T> = {
    pcs: PromiseCompletionSource<T>,
    cancellPrediction?: () => boolean;
}

export class VisibilityTimeoutObserver {
    private readonly timeout: number;
    private readonly operations: Array<CancellableOperation<any>>;

    private timeoutCancellationTokenSource: CancellationTokenSource;
    
    public constructor(timeout: number) {
        this.timeout = timeout;
        this.operations = [];
        this.onDocumentVisibilityChande = this.onDocumentVisibilityChande.bind(this);
        document.addEventListener('visibilitychange', this.onDocumentVisibilityChande);
    }

    public addOperation(pcs: PromiseCompletionSource<any>, cancellPrediction?: () => boolean): void {
        this.operations.push({ pcs, cancellPrediction });
    }

    public removeOperation(pcs: PromiseCompletionSource<any>): void {
        const operationIndex = this.operations.findIndex(value => value.pcs === pcs);
        if (operationIndex === -1) {
            return;
        }
        this.operations.splice(operationIndex, 1);
    }

    private async onDocumentVisibilityChande(): Promise<void> {
        if (document.hidden) {
            this.timeoutCancellationTokenSource?.cancel();
            this.timeoutCancellationTokenSource?.dispose();
            this.timeoutCancellationTokenSource = null;
            return;
        }

        if (this.operations.length === 0) {
            return;
        }

        if (this.timeoutCancellationTokenSource == null) {
            this.timeoutCancellationTokenSource = new CancellationTokenSource();
        }

        const source = this.timeoutCancellationTokenSource;
        const token = source.token;
        await TickerDelay.delay(this.timeout);
        if (!token.isCancellationRequested) {
            for (const operation of this.operations) {
                if(operation.cancellPrediction == null || operation.cancellPrediction()) {
                    operation.pcs.error(new Error("Timeout"));
                }
            }
            this.operations.splice(0, this.operations.length);
        }

        source?.dispose();
        if (this.timeoutCancellationTokenSource === source) {
            this.timeoutCancellationTokenSource = null;
        }
    }
}